import * as amplitude from '@amplitude/analytics-browser';
import { Experiment, Source } from '@amplitude/experiment-js-client';

export const initializeAmplitudeAnalyticsAndExperimentation = async (
    amplitudeDeploymentKey: string,
    customProperties: {
        hasEverPlacedBid: boolean;
        hasEverRegisteredForAuction: boolean;
    }
) => {
    const serverDeviceId = window.__amplitudeExperiments.deviceId;
    const serverUserId = window.__amplitudeExperiments.userId;

    // initialize amplitude analytics client
    amplitude.init(amplitudeDeploymentKey, {
        autocapture: {
            attribution: true,
            elementInteractions: false,
            fileDownloads: false,
            formInteractions: false,
            pageViews: true,
            sessions: false,
        },

        deviceId: serverDeviceId,
        logLevel: __DEVELOPMENT__ ? amplitude.Types.LogLevel.Warn : amplitude.Types.LogLevel.Error,
        userId: serverUserId,
    });

    // I don't believe we need this call, but commenting it out to see if it improves load times.
    // // wait for analytics init
    // await amplitudeAnalyticsClient.promise;

    // initialize amplitude experiments client
    const amplitudeExperimentsClient = Experiment.initializeWithAmplitudeAnalytics(amplitudeDeploymentKey, {
        automaticExposureTracking: false,
        automaticFetchOnAmplitudeIdentityChange: true,
        debug: false,
        fetchOnStart: false,
        initialVariants: window.__amplitudeExperiments.variants,
        retryFetchOnFailure: true,
        source: Source.LocalStorage,
        userProvider: {
            getUser: () => {
                return {
                    device_id: serverDeviceId,
                    user_id: serverUserId,
                    user_properties: {
                        'Has Ever Placed Bid': customProperties.hasEverPlacedBid,
                        'Has Ever Registered For Auction': customProperties.hasEverRegisteredForAuction,
                    },
                };
            },
        },
    });

    const client = await amplitudeExperimentsClient.fetch({
        device_id: serverDeviceId,
        user_id: serverUserId,
        user_properties: {
            'Has Ever Placed Bid': customProperties.hasEverPlacedBid,
            'Has Ever Registered For Auction': customProperties.hasEverRegisteredForAuction,
        },
    });

    return {
        amplitudeExperimentsClient: client,
    };
};
